import { cn } from '@udecode/cn';

import { formatNumber } from '../../utils/string.utils';

export interface DocumentProgressProps {
    characterCount: number;
    minCharacterCount: number;
    maxCharacterCount: number|null;
    normPageCharacterCount?: number;
}

export const DocumentProgress: React.FC<DocumentProgressProps> = ({
    characterCount,
    minCharacterCount,
    maxCharacterCount,
    normPageCharacterCount = 1800
}) => {
    const currentNormPageCount = characterCount / normPageCharacterCount;
    const minNormPageCount = minCharacterCount / normPageCharacterCount;
    const isOverMin = characterCount >= minCharacterCount;
    const isOverMax = maxCharacterCount !== null && characterCount > maxCharacterCount;
    const progressMax = Math.max(characterCount, maxCharacterCount ?? 1, minCharacterCount);
    const progressPercentage = Math.round(Math.max(0, characterCount / progressMax) * 100);
    const minMarkerPercentage = Math.round(Math.max(0, minCharacterCount / progressMax) * 100);
    const maxMarkerPercentage = maxCharacterCount !== null ? Math.round(Math.max(0, maxCharacterCount / progressMax) * 100) : null;
    const progressRealPercentage = minCharacterCount > 0 ? ((characterCount / minCharacterCount) * 100) : null;
    
    return (
        <div className='flex flex-col gap-2'>
            <div className='block relative w-full h-4 bg-gray-200 rounded-full overflow-hidden'>
                <div
                    className={cn(
                        'absolute left-0 top-0 bottom-0 transition-all duration-300',
                        'bg-[url(/assets/progressbar-noise-texture.jpg)] bg-cover bg-lef bg-blend-luminosity',
                        isOverMax
                            ? 'bg-red-600'
                            : isOverMin
                                ? 'bg-lime-600'
                                : 'bg-primary-500'
                    )}
                    style={{ width: `${progressPercentage}%` }}
                />
                <div
                    className='absolute top-0 bottom-0 w-[5px] bg-lime-500 border-l border-r border-white'
                    style={{ left: `${minMarkerPercentage}%` }}
                />
                {maxMarkerPercentage !== null && (
                    <div
                        className='absolute top-0 bottom-0 w-[5px] bg-red-600 border-l border-r border-white'
                        style={{ left: `${maxMarkerPercentage}%` }}
                    />  
                )}
                <div
                    className={cn(
                        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-xs font-semibold',
                        'text-gray-800',
                    )}
                >
                    {progressRealPercentage !== null && (
                        <>{formatNumber(progressRealPercentage, 1, ' ', ',')}%</>
                    )}
                </div>
            </div>
            <div className='text-sm text-gray-700 font-medium'>
                <span className='font-semibold'>{formatNumber(currentNormPageCount, 1, ' ', ',')}</span> {minNormPageCount > 0 && (<>/ {formatNumber(minNormPageCount, 1, ' ', ',')}</>)} NS {minNormPageCount > 0 && <>{'(min. počet)'}</>}
            </div>
        </div>
    );
};
